import { PureComponent } from 'react';

import { isNonNullable } from '@ipfabric/utils';
import { Map as ImmutableMap } from 'immutable';
import PropTypes from 'prop-types';
import OverviewPropTypes from '../../OverviewPropTypes';
import WidgetOptions from './WidgetOptions';

export default class TableColorsForm extends PureComponent {
  static propTypes = {
    allMessages: PropTypes.object.isRequired,
    Chart: OverviewPropTypes.Chart,
    editWidget: OverviewPropTypes.editWidget,
    msg: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onCreateReportGroup: PropTypes.func.isRequired,
    onFetchReports: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onToggleConfirmDialog: PropTypes.func.isRequired,
    onUpdateReportGroup: PropTypes.func.isRequired,
    reports: OverviewPropTypes.reports,
    reportsGroups: OverviewPropTypes.reportsGroups,
    selectedGroup: OverviewPropTypes.selectedGroup,
    widgetName: PropTypes.string.isRequired,
    widgetProps: OverviewPropTypes.widgetProps,
    columnIndex: OverviewPropTypes.columnIndex,
    rowIndex: OverviewPropTypes.rowIndex,
  };

  render() {
    const {
      allMessages,
      Chart,
      editWidget,
      msg,
      onClose,
      onCreateReportGroup,
      onFetchReports,
      onSubmit,
      onToggleConfirmDialog,
      onUpdateReportGroup,
      reports,
      reportsGroups,
      selectedGroup,
      widgetName,
      widgetProps,
      columnIndex,
      rowIndex,
    } = this.props;
    return (
      <div>
        <WidgetOptions
          Chart={Chart}
          allMessages={allMessages}
          columnIndex={columnIndex}
          editWidget={editWidget}
          initialValues={
            isNonNullable(widgetProps)
              ? new ImmutableMap(widgetProps)
              : new ImmutableMap({ group: 'tmp', name: '' })
          }
          msg={msg}
          onClose={onClose}
          onCreateReportGroup={onCreateReportGroup}
          onFetchReports={onFetchReports}
          onSubmit={onSubmit}
          onToggleConfirmDialog={onToggleConfirmDialog}
          onUpdateReportGroup={onUpdateReportGroup}
          reports={reports}
          reportsGroups={reportsGroups}
          rowIndex={rowIndex}
          selectedGroup={selectedGroup}
          widgetName={widgetName}
          widgetProps={widgetProps}
        />
      </div>
    );
  }
}
